import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static values = { text: String, successTitle: { type: String, default: "Copied!" } }

  connect() {
    this.tooltip = new Tooltip(this.element, {
      title: this.successTitleValue,
      trigger: 'manual',
      placement: 'top'
    })
  }

  copy(event) {
    event.preventDefault()

    navigator.clipboard.writeText(this.textValue).then(() => {
      this.showSuccess()
    })
  }

  showSuccess() {
    const icon = this.element.querySelector("i")

    // 1. Add a 'pressed' look using a custom CSS class or Bootstrap utility
    this.element.classList.add("btn-success", "scale-up")
    this.element.classList.remove("btn-outline-secondary")
    if (icon) icon.classList.replace("fa-link", "fa-check")

    // 2. Show the Tooltip
    this.tooltip.show()

    setTimeout(() => {
      this.tooltip.hide()
      this.element.classList.remove("btn-success", "scale-up")
      this.element.classList.add("btn-outline-secondary")
      if (icon) icon.classList.replace("fa-check", "fa-link")
    }, 1500)
  }

  disconnect() {
    if (this.tooltip) this.tooltip.dispose()
  }
}
